<script setup lang="ts">
import type { DateRange, DateValue } from 'reka-ui';
import type { WeekStartsOn } from './week';
import { CalendarRoot, RangeCalendarRoot } from 'reka-ui';
import { formatWeekDays } from './week';

defineProps<{
  layout: 'mobile' | 'desktop';
  oneWay: boolean;
  locale: string;
  weekStartsOn: WeekStartsOn;
  minValue?: DateValue;
  maxValue?: DateValue;
  numberOfMonths?: number;
  ghostStart?: DateValue;
}>();

const dateModel = defineModel<DateValue | undefined>('date');
const rangeModel = defineModel<DateRange>('range');
const placeholder = defineModel<DateValue>('placeholder');
</script>

<template>
  <CalendarRoot
    v-if="oneWay"
    v-model="dateModel"
    v-model:placeholder="placeholder"
    :number-of-months="numberOfMonths ?? (layout === 'mobile' ? 12 : 2)"
    :min-value="minValue"
    :max-value="maxValue"
    :locale="locale"
    weekday-format="short"
    :week-starts-on="weekStartsOn"
    disable-days-outside-current-view
  >
    <template #default="{ grid, weekDays }">
      <div :class="layout === 'mobile' ? 'flex flex-col gap-3' : 'flex'">
        <UiCustomRangeCalendarSingleGrid
          v-for="(month, i) in grid"
          :key="month.value.toString()"
          :month="month"
          :week-days="formatWeekDays(weekDays)"
          :vertical="layout === 'mobile'"
          :hide-nav="layout === 'mobile'"
          :is-first="layout === 'desktop' && i === 0"
          :is-last="layout === 'desktop' && i === grid.length - 1"
        />
      </div>
    </template>
  </CalendarRoot>
  <RangeCalendarRoot
    v-else
    v-model="rangeModel"
    v-model:placeholder="placeholder"
    :number-of-months="numberOfMonths ?? (layout === 'mobile' ? 12 : 2)"
    :min-value="minValue"
    :max-value="maxValue"
    :locale="locale"
    weekday-format="short"
    :week-starts-on="weekStartsOn"
    disable-days-outside-current-view
  >
    <template #default="{ grid, weekDays }">
      <div :class="layout === 'mobile' ? 'group flex flex-col gap-3' : 'group flex gap-6'">
        <UiCustomRangeCalendarGrid
          v-for="(month, i) in grid"
          :key="month.value.toString()"
          :month="month"
          :week-days="formatWeekDays(weekDays)"
          :vertical="layout === 'mobile'"
          :hide-nav="layout === 'mobile'"
          :is-first="layout === 'desktop' && i === 0"
          :is-last="layout === 'desktop' && i === grid.length - 1"
          :ghost-start="ghostStart"
        />
      </div>
    </template>
  </RangeCalendarRoot>
</template>
